import { convertHexToRgbA } from '../utils';

export const BACKGROUND = {
	main: '#043545',
	secondary: '#164859',
	snackbar: '#043545',
	input: '#3E3C37',
	modalView: convertHexToRgbA('#272D30', 0.8),
	modalViewSecondary: convertHexToRgbA('#171716', 0.8)
};

export const TRANSPARENT = {
	light10: convertHexToRgbA('#ffffff', 0.1),
	light15: convertHexToRgbA('#ffffff', 0.15),
	light20: convertHexToRgbA('#ffffff', 0.2),
	light30: convertHexToRgbA('#ffffff', 0.3),
	light45: convertHexToRgbA('#ffffff', 0.45),
	light50: convertHexToRgbA('#ffffff', 0.5),
	light60: convertHexToRgbA('#ffffff', 0.6)
};

export const ICON = {
	main: '#C7E914',
	secondary: '#B7B7B7',
	chevron: '#B7B7B7',
	hover: '#A3A2A2',
	pressed: '#8C8C8C',
	alwaysWhite: '#ffffff',
	notification: '#FF6964',
	warning: '#E37B4C',
	deposit: '#00D68F'
};

export const CONTROL = {
	primary: '#c7e914',
	hover: '#a9c709',
	pressed: '#C7E914',
	disabled: '#C7E914',
	secondary: '#009E69',
	secondaryHover: '#008f5f',
	secondaryPressed: '#009664',
	dark: '#164859',
	darkHover: '#1A586D',
	darkPressed: '#154656',
	darkToggle: '#74736F',
	light: '#ffffff',
	lightHover: '#E5E5E5',
	lightPressed: '#D9D9D9',
	lightToggle: '#B7B7B7'
};

export const TEXT = {
	title: '#FAF9F8',
	subtitle: '#DAD6CE',
	body: '#C2BDB2',
	link: '#00D68F',
	error: '#FF6964',
	warning: '#EC985B',
	alwaysWhite: '#ffffff',
	alwaysDark: '#292621'
};

export const OTHER = {
	calendarDefault: convertHexToRgbA('#0A0A09', 0.6),
	calendarActive: '#0A0A09',
	calendarBackgroundWhite: convertHexToRgbA('#ffffff', 0.25),
	calendarTextWhite: '#ffffff',
	calendarBackgroundDarkYellow: '#321E0F',
	calendarTextYellow: '#EC985B',
	calendarBackgroundDarkGreen: '#11362C',
	calendarTextGreen: '#009E69',
	calendarBackgroundDarkPurple: '#281E3B',
	calendarTextPurple: '#AE6FFF',
	calendarBackgroundDarkBlue: '#19334F',
	calendarTextBlue: '#1D92FF'
};

export const TAG = {
	textGreen: '#009E69',
	bgGreen: convertHexToRgbA('#009E69', 0.1),
	textBlue: '#2F8FC7',
	bgBlue: convertHexToRgbA('#2F8FC7', 0.1),
	textYellow: '#EC985B',
	bgYellow: convertHexToRgbA('#EC985B', 0.1),
	textRed: '#FF6964',
	bgRed: convertHexToRgbA('#FF6964', 0.1)
};

export const GAME_TAG_LOGO = {
	dota2Bg: convertHexToRgbA('#FF3333', 0.2),
	dota2Logo: '#FF3333',
	cs2Bg: convertHexToRgbA('#E2B603', 0.15),
	lolBg: convertHexToRgbA('#C79B3B', 0.15),
	lolLogo: '#C79B3B'
};
